import stationDataConfigApi from '@/api/config/stationDataConfig'
import { queryKeys } from '@/constant/common'
import { APIResponseList, SearchParams } from '@/types/common'
import { Station } from '@/types/station'
import { QueryOptions, useQuery, UseQueryResult } from '@tanstack/react-query'

function useSearchStation(
  searchParams: SearchParams = {},
  interfaceId: number,
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<Station>, any> {
  return useQuery(
    [queryKeys.stations, interfaceId, searchParams],
    async () => {
      const { data } = await stationDataConfigApi.getAll({
        ...searchParams,
        interfaceId,
      })

      if (!data) return null

      const stationList =
        data.data.length > 0 &&
        data?.data.map((item: any) => {
          return {
            id: item.id,
            controller: item.controller,
            decoderType: item.decoderType,
            state: item.state,
            plant: item.plant,
            emitter: item.emitter,
            etRuntime: item.etRuntime,
            interfaceId: item.interfaceId,
            index: item.index,
            address: item.address,
            type: item.type,
            stationType: item.stationType,
            soil: item.soil,
            errorCode: item.errorCode,
            errorName: item.errorName,
            waterRequired: item.waterRequired,
            surfaceAccumulation: item.surfaceAccumulation,
            precipitationRate: item.precipitationRate,
            expectedFlow: item.expectedFlow,
            landscapeFactor: item.landscapeFactor,
            etZone: item.etZone,
            rtDayOverride: item.rtDayOverride,
            pipe: item.pipe,
            defaultRunTime: item.defaultRunTime,
            observedFlow: item.observedFlow,
            plantAvailWater: item.plantAvailWater,
            stateName: item.stateName,
            description: item.description,
            subArea: item.subArea,
            priority: item.priority,
            floorId: item.floorId,
            locationId: item.locationId,
            subAreaId: item.subAreaId,
            plantId: item.plantId,
            soilId: item.soilId,
            emitterId: item.emitterId,
            // Geo-tag lat/long — needed so a bulk-edit PUT round-trips the
            // existing pin instead of sending null and wiping it.
            grsCoordinatedLatitude: item.grsCoordinatedLatitude,
            grsCoordinatedLongitude: item.grsCoordinatedLongitude,
          }
        })

      return {
        list: stationList,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
        unpinnedStations: data.unpinnedStations,
      }
    },
    queryOptions,
  )
}

export default useSearchStation
